import { fmtBytes } from './eventLog.js';

export function renderDetail(container, ev) {
  if (!ev) {
    container.innerHTML = '<div class="empty">Click an event row to inspect headers.</div>';
    return;
  }
  const req = ev.requestHeaders;
  const res = ev.responseHeaders;
  container.innerHTML = '';
  container.appendChild(section('Event', kv([
    ['t', ev.ts.toFixed(3) + ' s'],
    ['user', ev.userId],
    ['url', ev.url],
    ['kind', ev.kind + (ev.failure ? ' (' + ev.failure + ')' : '')],
    ['bytes over wire', fmtBytes(ev.bytesOverWire)],
    ['asset', ev.assetId + ' @v' + ev.currentVersion],
    ...(ev.delta ? [['delta', `v${ev.delta.fromVersion} → v${ev.delta.toVersion} (${fmtBytes(ev.delta.sizeBytes)})`]] : []),
    ...(ev.clientDict ? [['client dict', ev.clientDict.id + ' (v' + ev.clientDict.sourceVersion + ')']] : []),
    ...(ev.dictAdvertised ? [['advertises dict', ev.dictAdvertised.id]] : []),
  ])));
  if (ev.kind === 'cache') {
    const note = document.createElement('div');
    note.className = 'empty';
    note.style.marginTop = '8px';
    note.textContent = 'No network I/O — response served from client cache (fresh within max-age).';
    container.appendChild(note);
    return;
  }
  container.appendChild(section('Request', headerBlock('GET ' + ev.url + ' HTTP/1.1', req)));
  container.appendChild(section('Response',
    headerBlock(statusLine(ev), res)));
}

function statusLine(ev) {
  if (ev.kind === 'cache') return '(client cache hit — no network)';
  if (ev.statusCode === 304) return 'HTTP/1.1 304 Not Modified';
  return `HTTP/1.1 ${ev.statusCode ?? 200} OK`;
}

function section(title, node) {
  const wrap = document.createElement('div');
  const h = document.createElement('h4'); h.textContent = title;
  wrap.appendChild(h);
  wrap.appendChild(node);
  return wrap;
}

function kv(entries) {
  const grid = document.createElement('div'); grid.className = 'kv';
  for (const [k, v] of entries) {
    const kk = document.createElement('div'); kk.className = 'k'; kk.textContent = k;
    const vv = document.createElement('div'); vv.className = 'v'; vv.textContent = v;
    grid.appendChild(kk); grid.appendChild(vv);
  }
  return grid;
}

function headerBlock(startLine, headers) {
  const pre = document.createElement('pre');
  const lines = [startLine];
  for (const [k, v] of Object.entries(headers)) {
    lines.push(`\u001b[hdr]${k}\u001b[/hdr]: ${v}`);
  }
  // Colorize header names via spans; escape codes above are placeholders.
  pre.innerHTML = lines.map((line, i) => {
    if (i === 0) return escapeHtml(line);
    return line.replace(/^\u001b\[hdr\](.+?)\u001b\[\/hdr\]: (.*)$/, (m, name, val) =>
      `<span class="hdr-name">${escapeHtml(name)}</span>: <span class="hdr-value">${escapeHtml(val)}</span>`);
  }).join('\n');
  return pre;
}

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
}
